export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <rect x="1" y="1" width="38" height="38" rx="10" fill="#0B1A2E" stroke="#ffffff" strokeOpacity=".18" />
    <path d="M20 7C21.3 15.4 24.6 18.7 33 20 24.6 21.3 21.3 24.6 20 33 18.7 24.6 15.4 21.3 7 20 15.4 18.7 18.7 15.4 20 7Z" fill="#00D26A" />
    <circle cx="30.5" cy="9.5" r="2" fill="#E8F1FF" />
  </svg>
);

export const Logo = ({ className = "" }) => (
  <span className={`flex items-center gap-3 ${className}`}>
    <LogoMark />
    <span className="font-display text-[17px] font-semibold leading-none tracking-tight">
      Shine<span className="text-glint">.</span>
      <span className="ml-1 font-light opacity-70">Solutions</span>
    </span>
  </span>
);
